export const scheduleHeaders = ['月份', '省区', '医院编号', '医院', '科室编号', '科室', '医生编号', '医生', '排班日期', '基础状态', '开始时间', '结束时间', '备注']
export const scheduleSheet = '当月基础排班'
export const maxScheduleRows = 100000

const excelDate = value => new Date(value + 'T00:00:00Z')
const dateText = value => value instanceof Date ? value.toISOString().slice(0, 10) : String(value == null ? '' : value).trim()
const plainText = value => {
  if (value == null) return ''
  if (typeof value === 'object') {
    if (value.richText) return value.richText.map(part => part.text).join('').trim()
    throw new Error('请填写普通值，不能使用公式、超链接或错误单元格')
  }
  return String(value).trim()
}
const timeText = value => {
  if (value instanceof Date) return value.toISOString().slice(11, 16)
  if (typeof value === 'number' && value >= 0 && value < 1) {
    const minutes = Math.round(value * 1440)
    if (minutes >= 1440 || Math.abs(minutes / 1440 - value) > 0.000001) throw new Error('时间精度必须为分钟')
    return String(Math.floor(minutes / 60)).padStart(2, '0') + ':' + String(minutes % 60).padStart(2, '0')
  }
  return plainText(value)
}

// ExcelJS 由页面按需加载。本模块也可用实际 Workbook 进行往返验证。
export function buildScheduleWorkbook (ExcelJS, template) {
  if (!template || !/^\d{4}-\d{2}$/.test(template.month)) throw new Error('模板月份无效')
  if (!template.rows || !template.rows.length) throw new Error('当前权限范围内没有有效医生')
  if (template.rows.length > maxScheduleRows) throw new Error('模板超过100000行，请联系管理员分批维护')
  const workbook = new ExcelJS.Workbook()
  workbook.creator = '鲸迹知行'
  const sheet = workbook.addWorksheet(scheduleSheet, { views: [{ state: 'frozen', xSplit: 8, ySplit: 1, showGridLines: false }] })
  const widths = [12, 12, 12, 38, 12, 20, 12, 14, 16, 14, 14, 14, 45]
  sheet.columns = scheduleHeaders.map((header, index) => ({ header, width: widths[index] }))
  ;[3, 5, 7].forEach(index => { sheet.getColumn(index).hidden = true })
  const header = sheet.getRow(1)
  header.height = 30
  header.eachCell(cell => {
    cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FF244B72' } }
    cell.font = { name: 'Arial', size: 11, bold: true, color: { argb: 'FFFFFFFF' } }
    cell.alignment = { vertical: 'middle', horizontal: 'center' }
  })
  template.rows.forEach(item => {
    const row = sheet.addRow([template.month, item.region_name, item.hospital_sjid, item.hospital_name, item.department_sjid, item.department_name, item.doctor_sjid, item.doctor_name, excelDate(item.date), { WORKING: '上班', OFF: '休息' }[item.status] || '', item.start_time || '', item.end_time || '', item.remark || ''])
    row.height = 24
    for (let index = 1; index <= scheduleHeaders.length; index++) {
      const cell = row.getCell(index)
      if (cell.value === '') cell.value = null
      cell.font = { name: 'Arial', size: 11, color: { argb: index <= 9 ? 'FF53677C' : 'FF1D3550' } }
      cell.alignment = { vertical: 'middle', horizontal: 'left' }
      cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: index <= 9 ? (row.number % 2 ? 'FFF1F5F9' : 'FFF8FAFC') : 'FFFFF4CC' } }
      cell.numFmt = index === 9 ? 'yyyy-mm-dd' : '@'
    }
    row.getCell(10).dataValidation = { type: 'list', allowBlank: true, formulae: ['"上班,休息"'], showErrorMessage: true, errorTitle: '基础状态无效', error: '请选择上班或休息。空白表示不导入。', errorStyle: 'stop' }
  })
  sheet.autoFilter = { from: 'A1', to: 'M' + sheet.rowCount }
  const guide = workbook.addWorksheet('填写说明', { views: [{ showGridLines: false }] })
  guide.getColumn(1).width = 118
  const instructions = [
    '医生当月基础排班填写说明',
    '模板月份：' + template.month + '。来源：系统当前权限范围内全部有效医院、科室、医生，不受列表筛选影响。',
    '一位医生一天一行。灰色区域及隐藏的编号列用于匹配系统医生，请勿修改。可筛选、排序和删除不需要导入的行。',
    '黄色区域可维护：基础状态、开始时间、结束时间、备注。基础状态请选择上班或休息。',
    '上班必须填写有效的 HH:mm 时间，开始早于结束，例如 08:00 至 17:00。休息必须清空开始和结束时间。',
    '状态、时间和备注均为空的行会跳过，系统原有基础排班保持不变。备注最多500字。',
    '模板预填已有的当月基础排班，没有当月基础时预填原基础周排班。未维护的日期留空。',
    '仅能导入系统当前月份，包含当月所有日期。跨月后请重新导出模板。只接受 .xlsx 文件及普通值，不接受公式。',
    '导入前先预览，发现错误时整批不保存。导入按医生编号和日期更新基础排班，重复导入不会新增重复记录。',
    '已有请假或临时调整继续优先生效，导入不会覆盖这些调整。取消日期调整后恢复基础排班。'
  ]
  instructions.forEach((line, index) => {
    const row = guide.addRow([line]); row.height = index === 0 ? 32 : 42
    row.getCell(1).font = { name: 'Arial', size: index === 0 ? 15 : 11, bold: index === 0, color: { argb: 'FF244B72' } }
    row.getCell(1).alignment = { vertical: 'middle', wrapText: true }
  })
  return workbook
}

export function parseScheduleWorkbook (workbook, template) {
  const sheet = workbook.getWorksheet(scheduleSheet)
  if (!sheet) throw new Error('缺少“当月基础排班”工作表，请使用系统导出的模板')
  scheduleHeaders.forEach((label, index) => {
    if (plainText(sheet.getRow(1).getCell(index + 1).value) !== label) throw new Error('模板表头被修改，请重新导出模板')
  })
  if (sheet.rowCount > maxScheduleRows + 1) throw new Error('最多导入100000行')
  const identities = new Map(template.rows.map(row => [row.doctor_sjid, row]))
  const seen = new Set()
  const result = { month: template.month, rows: [], errors: [], error_count: 0, skipped: 0, doctor_count: 0 }
  const doctors = new Set()
  const fail = (number, message) => { result.error_count++; if (result.errors.length < 100) result.errors.push('第' + number + '行：' + message) }
  for (let number = 2; number <= sheet.rowCount; number++) {
    try {
      const row = sheet.getRow(number)
      // 即使状态留空，也不能悄悄跳过已经填写的时间或备注。
      const statusValue = plainText(row.getCell(10).value)
      const start = timeText(row.getCell(11).value); const end = timeText(row.getCell(12).value)
      const remark = plainText(row.getCell(13).value)
      if (!statusValue && !start && !end && !remark) { result.skipped++; continue }
      const values = Array.from({ length: 8 }, (_, index) => plainText(row.getCell(index + 1).value))
      const date = dateText(row.getCell(9).value)
      if (values[0] !== template.month || date.slice(0, 7) !== template.month) throw new Error('月份或排班日期不属于系统当前月份 ' + template.month)
      if (!/^\d{4}-\d{2}-\d{2}$/.test(date) || Number.isNaN(excelDate(date).getTime()) || excelDate(date).toISOString().slice(0, 10) !== date) throw new Error('排班日期无效，请使用 yyyy-MM-dd')
      const identity = identities.get(values[6])
      if (!identity) throw new Error('医生编号不存在、已停用或不在当前权限范围内')
      const expected = [template.month, identity.region_name, identity.hospital_sjid, identity.hospital_name, identity.department_sjid, identity.department_name, identity.doctor_sjid, identity.doctor_name]
      if (values.some((value, index) => value !== expected[index])) throw new Error('医院/科室/医生信息与系统不一致，请重新导出模板')
      const status = { 上班: 'WORKING', 休息: 'OFF', WORKING: 'WORKING', OFF: 'OFF' }[statusValue]
      if (!status) throw new Error('基础状态只能为上班或休息')
      if (status === 'WORKING' && (!/^([01]\d|2[0-3]):[0-5]\d$/.test(start) || !/^([01]\d|2[0-3]):[0-5]\d$/.test(end) || start >= end)) throw new Error('上班必须填写有效 HH:mm 时间，且开始早于结束')
      if (status === 'OFF' && (start || end)) throw new Error('休息日请清空开始和结束时间')
      if (remark.length > 500) throw new Error('备注不能超过500字')
      const key = identity.doctor_sjid + '|' + date
      if (seen.has(key)) throw new Error('同一医生同一天的排班重复')
      seen.add(key); doctors.add(identity.doctor_sjid)
      result.rows.push({ row_no: number, region_name: identity.region_name, hospital_sjid: identity.hospital_sjid, hospital_name: identity.hospital_name, department_sjid: identity.department_sjid, department_name: identity.department_name, doctor_sjid: identity.doctor_sjid, doctor_name: identity.doctor_name, date, status, start_time: start, end_time: end, remark })
    } catch (error) { fail(number, error.message) }
  }
  result.doctor_count = doctors.size
  return result
}
